import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/site/Header";

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/admin/login", { password });
      onLogin(data.token);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative grid min-h-screen place-items-center px-5 grid-lines">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-80 w-80 -translate-x-1/2 rounded-full bg-gold/15 blur-[120px]" />
      <form onSubmit={submit} data-testid="admin-login-form" className="glass relative w-full max-w-md rounded-3xl p-8 sm:p-10">
        <Logo testId="admin-logo" />
        <h1 className="font-display mt-8 text-3xl font-bold text-navy-900">Admin Login</h1>
        <p className="mt-1 text-slate-500">Enter password to view leads</p>
        <div className="relative mt-8">
          <Lock className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-500" />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            data-testid="admin-login-password-input"
            className="h-14 w-full rounded-2xl border border-slate-200 bg-white pl-12 pr-4 text-lg text-navy-900 outline-none focus:border-gold/60"
          />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-3 text-[15px] text-red-600">{error}</p>}
        <button type="submit" disabled={loading || !password} data-testid="admin-login-submit-btn" className="btn-gold mt-6 h-14 w-full text-lg disabled:opacity-50">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Login"}
        </button>
      </form>
    </div>
  );
};
